import gql from 'graphql-tag';
export default gql`
  mutation updateShortlists($applicationId: String, $userId: String!, $shortlists: JSON) {
    updateShortlists(applicationId: $applicationId, userId: $userId, shortlists: $shortlists) {
      success
      message
      results {
        userProfile
        vehicleApplication
      }
    }
  }
`;
